/**
 * Monthlees supplement facts — modal + flavor panel switching.
 * Supports open triggers inside the root OR external buttons via
 * data-msf-modal-root="#id-of-data-monthlees-supplement-facts".
 */
(function () {
  'use strict';

  function openModal(root) {
    if (!root) return;
    var modal = root.querySelector('[data-msf-modal]');
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');
    var flavorTabs = root.querySelectorAll('[data-msf-flavor-tab]');
    var firstTab = root.querySelector('[data-msf-flavor-tab].is-active') || flavorTabs[0];
    if (firstTab) {
      setActiveFlavor(root, firstTab.getAttribute('data-msf-flavor-tab'));
    }
  }

  function closeModal(root) {
    if (!root) return;
    var modal = root.querySelector('[data-msf-modal]');
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
  }

  function setActiveFlavor(root, panelId) {
    var flavorTabs = root.querySelectorAll('[data-msf-flavor-tab]');
    var flavorPanels = root.querySelectorAll('[data-msf-flavor-panel]');
    flavorTabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-msf-flavor-tab') === panelId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });
    flavorPanels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-msf-flavor-panel') === panelId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  function resolveRoot(trigger) {
    var rootSel = trigger.getAttribute('data-msf-modal-root');
    if (rootSel) {
      try {
        return document.querySelector(rootSel);
      } catch (e) {
        return null;
      }
    }
    return trigger.closest('[data-monthlees-supplement-facts]');
  }

  function bindRoot(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var modal = root.querySelector('[data-msf-modal]');
    var dialog = root.querySelector('.monthlees-sup-facts__modal-dialog');
    var closeEls = root.querySelectorAll('[data-msf-modal-close]');
    var flavorTabs = root.querySelectorAll('[data-msf-flavor-tab]');

    root.querySelectorAll('[data-msf-open-modal]').forEach(function (openTrigger) {
      openTrigger.addEventListener('click', function () {
        openModal(root);
      });
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', function () {
        closeModal(root);
      });
    });

    if (modal && dialog) {
      modal.addEventListener('click', function (event) {
        if (!dialog.contains(event.target)) {
          closeModal(root);
        }
      });
    }

    flavorTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActiveFlavor(root, tab.getAttribute('data-msf-flavor-tab'));
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal(root);
      }
    });
  }

  function bindExternalTriggers() {
    document.querySelectorAll('[data-msf-open-modal][data-msf-modal-root]').forEach(function (btn) {
      if (btn.dataset.msfExternalBound === 'true') return;
      btn.dataset.msfExternalBound = 'true';
      btn.addEventListener('click', function () {
        var root = resolveRoot(btn);
        if (!root) return;
        bindRoot(root);
        openModal(root);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-monthlees-supplement-facts]').forEach(bindRoot);
    bindExternalTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
